import OfficialExamResult from './OfficialExamResult';

export default OfficialExamResult;
